import React, { useState } from "react";
import { Typography, Box, Stack, Grid2 } from "@mui/material";
import ClientInfoDetail from "../components/patientDetail/clientInfoDetail";
import ServiceScheduleDetail from "../components/patientDetail/serviceScheduleDetail";
import ServiceDetail from "../components/patientDetail/serviceDetail";
import ServiceAddressDetail from "../components/patientDetail/serviceAddressDetail";
import CareStatusDetail from "../components/patientDetail/careStatusDetail";
import AuthorizedContactDetail from "../components/patientDetail/authorizedContactDetail";
import EmergencyPlanningDetail from "../components/patientDetail/emergencyPlanningDetail";
import BillingInformation from "../components/patientDetail/billingInformation";
import LegalTermsDetail from "../components/patientDetail/legalTermsDetail";
import GeneratePdf from "../components/patientDetail/generatePdf";
import DocumentationDetail from "../components/patientDetail/documentationDetail";
import PaymentBaseRateDetails from "../components/patientDetail/paymentBaseRateDetails";
const ReviewPdfField = ({ formContext, onSubmit }) => {
  const { formData } = formContext || {};
  return (
    <>
      <Box mb={2}>
        <ClientInfoDetail formData={formData} fromReview={true} />
      </Box>
      <Box mb={2}>
        <ServiceScheduleDetail formData={formData} fromReview={true} />
      </Box>
      <Box mb={2}>
        <ServiceDetail formData={formData} fromReview={true} />
      </Box>
      <Box mb={2}>
        <ServiceAddressDetail formData={formData} fromReview={true} />
      </Box>
      <Box mb={2}>
        <CareStatusDetail formData={formData} fromReview={true} />
      </Box>
      <Box mb={2}>
        <AuthorizedContactDetail formData={formData} fromReview={true} />
      </Box>
      <Box mb={2}>
        <EmergencyPlanningDetail formData={formData} fromReview={true} />
      </Box>
      <Box mb={2}>
        <DocumentationDetail formData={formData} fromReview={true} />
      </Box>
      <Box mb={2}>
        <PaymentBaseRateDetails formData={formData} fromReview={true} />
      </Box>
      <Box mb={2}>
        <BillingInformation formData={formData} fromReview={true} />
      </Box>
      <Box mb={2}>
        <LegalTermsDetail formData={formData} fromReview={true} />
      </Box>
      <GeneratePdf
        formData={formData}
        label={"Export as PDF"}
        isPrintIcon={true}
        variant={"contained"}
      />
    </>
  );
};

export default ReviewPdfField;
